import { GenericService } from '../Generic.service';

export class ComponentLacunasService extends GenericService {
    readonly URI: string = '/v1/componentLacuna';

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public deleteById(idComponente: number) {
        return this.delete(idComponente);
    }
}
